import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import CarLevelsModal from "components/Modals/CarLevelsModal/CarLevelsModal";
import RaceLevelsModal from "components/Modals/RaceLevelsModal/RaceLevelsModal";
import { raceLevelGradient } from "utils/themeConstants";

const raceColors = {
  1: 'cerebralGrey.100',
  2: 'secondaryGrey.100',
  3: 'uncommon.100',
  4: 'rare.100',
  5: 'epic.100',
  6: 'legendary.100',
}

const RaceLevel = ({ 
  level, 
  textFontSize, 
  numberFontSize, 
  minW,
  isRaceLevel = false,
  size = "normal"
}: { 
  level: number, 
  textFontSize?: string | Record<string, string>, 
  numberFontSize?: string | Record<string, string>, 
  minW?: string, 
  isRaceLevel?: boolean,
  size?: "small" | "normal"
}) => {
  const { isOpen: isRaceLevelsModalOpen, onOpen: onRaceLevelsModalOpen, onClose: onRaceLevelsModalClose } = useDisclosure();
  
  const { isOpen: isCarLevelModalOpen, onOpen: onCarLevelModalOpen, onClose: onCarLevelModalClose } = useDisclosure();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (isRaceLevel) {
      onRaceLevelsModalOpen();
    } else {
      onCarLevelModalOpen();
    }
  }
  return (
    <>
      <Flex
        background={raceLevelGradient[level as keyof typeof raceLevelGradient]}
        borderTopRightRadius="12px"
        borderBottomLeftRadius="12px"
        borderTopLeftRadius="2px"
        borderBottomRightRadius="2px"
        px={size === "small" ? "1.5" : "2"}
        py={size === "small" ? "1.5" : "2"}
        minW={minW || "58px"}
        alignItems="center"
        justifyContent="center"
        gap="1"
        position="relative"
        cursor="pointer"
        onClick={handleClick}
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          borderTopRightRadius: "12px",
          borderBottomLeftRadius: "12px",
          borderTopLeftRadius: "2px",
          borderBottomRightRadius: "2px",
          padding: "2px",
          background: "linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
        style={{
          backgroundOrigin: 'border-box',
        }}
      >
        <Text
          fontSize={textFontSize || "10px"}
          lineHeight={textFontSize || "10px"}
          fontWeight="600"
          color="white.80"
        >
          LEVEL
        </Text>
        <Text
          fontSize={numberFontSize || "14px"}
          lineHeight={numberFontSize || "14px"}
          fontFamily="heading"
          fontWeight="400"
          color="white.80"
        >
          {level}
        </Text>
      </Flex>

      <RaceLevelsModal
        isOpen={isRaceLevelsModalOpen}
        onClose={onRaceLevelsModalClose}
      />

      <CarLevelsModal
        isOpen={isCarLevelModalOpen}
        onClose={onCarLevelModalClose}
      />
    </>
  )
}

export default RaceLevel;